import { useId, useRef, type ChangeEvent } from 'react'
import { _x } from '@wordpress/i18n'
import {
  getDateFilters,
  type TDateFilter
} from '../../../../assets/constants/datetime'
import FilterTag from '../../../../assets/frontend/js/components/FilterTag'
import {
  useFilters,
  type TDateFilterDirection
} from './EventsFiltersController'

export default function TimeFrameFilter(props: {
  title: string
  ariaLabel: string
  ids: string[]
}) {
  const dateFilterValues = useRef(getDateFilters(props.ids))

  const { frame, refineFrame, direction, refineDirection } = useFilters()

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const id = event.target.value as TDateFilter
    if (!id) return
    refineFrame(
      id === frame?.id
        ? undefined
        : { id, range: getDateFilters(id)?.value ?? [undefined, undefined] }
    )
  }

  const onPreviousFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as TDateFilterDirection
    refineDirection(direction !== value ? value : undefined)
  }

  const id = useId()

  return (
    <fieldset aria-label={props.ariaLabel}>
      <legend className="filter-title">{props.title}</legend>
      <div className="filter-tags">
        {dateFilterValues.current.map((item) => (
          <FilterTag
            key={item.label}
            id={`event-filter-date-${item.label}`}
            name="date"
            value={item.id}
            label={item.label}
            checked={frame?.id === item.id}
            onChange={onChange}
          />
        ))}
        <FilterTag
          id={`date-filter-previous-${id}`}
          name="date"
          value="past"
          label={_x('Past', 'Events List Time Frame Filter', 'icf')}
          checked={direction === 'past'}
          onChange={onPreviousFilterChange}
        />
      </div>
    </fieldset>
  )
}
